import React from "react";
import { css } from "@emotion/react";
import { useTheme } from "@emotion/react";

import SessionFormInput from "@ats/src/views/sessions/components/SessionFormInput";
import FormContainer from "@ats/src/components/forms/FormContainer";
import SessionButton from "@ats/src/views/sessions/components/SessionButton";

import { validateNewOrganization } from "@shared/lib/validateWithYup";
import { useCreateOrganization } from "@shared/queryHooks/useOrganization";
import breakpoint from "@shared/styles/breakpoints";

function OrganizationForm(props) {
  const { onComplete, currentOrganization } = props;
  const [name, setName] = React.useState("");
  const [heardAboutUsFrom, setHeardAboutUsFrom] = React.useState("");
  const [errors, setErrors] = React.useState(null);
  const theme: any = useTheme();
  const { mutate: createOrganization, isLoading } = useCreateOrganization();

  const handleNameChange = (name, value) => {
    setName(value);
  };

  const handleHeardAboutUsFromChange = (name, value) => {
    setHeardAboutUsFrom(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const [isValid, validationErrors] = await validateNewOrganization({ name });

    if (isValid) {
      try {
        if (window.__adroll) {
          window.logger(
            "%c[OrganizationForm] recording user to AdRoll for org_form_complete",
            "background-color:rgb(248, 245, 76); color: #1976D2",
          );
          window.__adroll.record_user({
            adroll_segments: "8943ffe3",
            adroll_user_identifier: props.currentUser?.id,
            adroll_custom_data: { USER_ID: props.currentUser?.id },
          });
        }
      } catch (error) {
        window.logger(
          "%c[OrganizationForm] error recording user to AdRoll",
          "background-color:rgb(248, 245, 76); color: #1976D2",
          error,
        );
      }
      createOrganization(
        { name, heardAboutUsFrom },
        {
          onSuccess: (data) => {
            window.logger("[OrganizationForm] createOrganization onSuccess", { data });
            onComplete(data);
          },
          onError: (response: any) => {
            setErrors(response.data.errors);
          },
        },
      );
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <FormContainer
      onSubmit={handleSubmit}
      buttons={
        <div
          css={css`
            display: flex;
            justify-content: space-between;
            flex-direction: column;

            ${breakpoint.xxs} {
              flex-direction: row;
            }
          `}
        >
          <SessionButton type="submit" disabled={isLoading} loading={isLoading}>
            Create organization
          </SessionButton>
          {currentOrganization != undefined ? (
            <SessionButton
              type="internalLink"
              styleType="largeSecondary"
              disabled={isLoading}
              link={`/organization/manage`}
              css={css`
                margin-top: 16px;  

                ${breakpoint.xxs} {
                  margin-top: 0;
                }
              `}
            >
              Cancel
            </SessionButton>
          ) : null}
        </div>
      }
    >
      <SessionFormInput
        onChange={handleNameChange}
        name="name"
        placeholder=""
        label="Organization name"
        className=""
        value={name}
        errors={errors}
        isRequired={true}
      />

      <SessionFormInput
        onChange={handleHeardAboutUsFromChange}
        name="heardAboutUsFrom"
        placeholder=""
        label="How did you hear about us?"
        className=""
        value={heardAboutUsFrom}
        errors={errors}
      />

      {/* <FormInput
          name="slug"
          description="The URL that your organization's Polymer job board will be visible at. For example: https://jobs.polymer.co/organization-name"
          pretext="https://jobs.polymer.co/"
          placeholder="..."
          label="Job board URL"
          className=""
          value={slug}
          errors={errors}
        /> */}
    </FormContainer>
  );
}

export default OrganizationForm;
